/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ShivaWebSecuredConfiguration } from '../shiva-web-secured-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { getUserAllowedScopes } from '../fn/login/get-user-allowed-scopes';
import { GetUserAllowedScopes$Params } from '../fn/login/get-user-allowed-scopes';
import { login } from '../fn/login/login';
import { Login$Params } from '../fn/login/login';
import { loginAuthentification } from '../fn/login/login-authentification';
import { LoginAuthentification$Params } from '../fn/login/login-authentification';
import { UserProfileSummary } from '../models/user-profile-summary';


/**
 * All about the user login
 */
@Injectable({ providedIn: 'root' })
export class LoginService extends BaseService {
  constructor(config: ShivaWebSecuredConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `getUserAllowedScopes()` */
  static readonly GetUserAllowedScopesPath = '/user/scopes';

  /**
   * Return, from the list of provided scopes, which scopes the user has access to.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getUserAllowedScopes()` instead.
   *
   * This method doesn't expect any request body.
   */
  getUserAllowedScopes$Response(params: GetUserAllowedScopes$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<string>>> {
    return getUserAllowedScopes(this.http, this.rootUrl, params, context);
  }

  /**
   * Return, from the list of provided scopes, which scopes the user has access to.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getUserAllowedScopes$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getUserAllowedScopes(params: GetUserAllowedScopes$Params, context?: HttpContext): Observable<Array<string>> {
    return this.getUserAllowedScopes$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<string>>): Array<string> => r.body)
    );
  }

  /** Path part for operation `login()` */
  static readonly LoginPath = '/login';

  /**
   * Login user.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `login()` instead.
   *
   * This method doesn't expect any request body.
   */
  login$Response(params?: Login$Params, context?: HttpContext): Observable<StrictHttpResponse<UserProfileSummary>> {
    return login(this.http, this.rootUrl, params, context);
  }

  /**
   * Login user.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `login$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  login(params?: Login$Params, context?: HttpContext): Observable<UserProfileSummary> {
    return this.login$Response(params, context).pipe(
      map((r: StrictHttpResponse<UserProfileSummary>): UserProfileSummary => r.body)
    );
  }

  /** Path part for operation `loginAuthentification()` */
  static readonly LoginAuthentificationPath = '/login/auth';

  /**
   * Authentification login user.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `loginAuthentification()` instead.
   *
   * This method doesn't expect any request body.
   */
  loginAuthentification$Response(params?: LoginAuthentification$Params, context?: HttpContext): Observable<StrictHttpResponse<UserProfileSummary>> {
    return loginAuthentification(this.http, this.rootUrl, params, context);
  }

  /**
   * Authentification login user.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `loginAuthentification$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  loginAuthentification(params?: LoginAuthentification$Params, context?: HttpContext): Observable<UserProfileSummary> {
    return this.loginAuthentification$Response(params, context).pipe(
      map((r: StrictHttpResponse<UserProfileSummary>): UserProfileSummary => r.body)
    );
  }

}
